<template>
    <div class="ListingImages" v-if="images.length > 0">
        <LightBox v-if="showLightBox"
            :images="images"
            :showLightBox="showLightBox"
            :startAt="startAt"
            @onOpened="closeLightBox">
        </LightBox>

        <Slick
            ref="slider"
            class="slider"
            :options="slickOptions"
        >
            <div v-for="(image, index) of images" :key="index">
                <el-image fit="contain" :src="image.src" @click.native="toLightBox(index)">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                    </div>
                </el-image>
            </div>
        </Slick>

        <Slick
            ref="sliderNav"
            class="sliderNav"
            :options="slickNavOptions"
        >
            <div v-for="(image, index) of images" :key="index">
                <div class="thumbnail" :style="{ backgroundImage: 'url(' + image.src + ')' }"></div>
            </div>
        </Slick>
    </div>
</template>

<script>
    import LightBox from 'vue-image-lightbox'
    import '../../../node_modules/vue-image-lightbox/dist/vue-image-lightbox.min.css'
    import Slick from 'vue-slick'

    export default {
        name: 'listing-images',

        components: {
            LightBox,
            Slick
        },

        props: {
        },

        computed: {
            images() {
                return this.$store.getters['property/images']
            }
        },

        updated() {
            this.beforeUpdate()
            this.updated()
            this.beforeNavUpdate()
            this.updatedNav()
        },

        data:function() {
            return {
                startAt: 0,
                showLightBox: false,
                autoPlay: true,
                autoplayHoverPause: true,
                perPage: [[1, 1], [768, 2], [1024, 3]],
                navigationEnabled: true,
                navigationClickTargetSize: 15, //default 8

                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    cssEase: 'linear',
                    asNavFor: '.sliderNav'
                },

                slickNavOptions: {
                    vertical: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    asNavFor: '.slider',
                    focusOnSelect: true
                }
            }
        },

        methods: {
            toLightBox(index) {
                this.startAt = index
                this.showLightBox = true
            },
            closeLightBox(e) {
                this.showLightBox = e
            },
            beforeUpdate() {
                if (this.$refs.slider) {
                    this.$refs.slider.destroy();
                }
            },
            updated() {
                this.$nextTick(function () {
                    if (this.$refs.slider) {
                        this.$refs.slider.create(this.slickOptions);
                    }
                });
            },
            beforeNavUpdate() {
                if (this.$refs.sliderNav) {
                    this.$refs.sliderNav.destroy();
                }
            },
            updatedNav() {
                this.$nextTick(function () {
                    if (this.$refs.sliderNav) {
                        this.$refs.sliderNav.create(this.slickOptions);
                    }
                });
            },
        }
    }
</script>

<style lang="scss">
    .ListingImages {
        position: relative;
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 0 0 1rem 0;

        .slider, .sliderNav {
            margin: 0;
            padding: 0;
            float: left;
            height: 500px;

            .slick-slide {
                display: inline-block;
                padding: 0;
                text-align: center;
            }

            .el-image {
                display: inline-block;
                width: 100%;
                height: 500px;

                img {
                    vertical-align: middle;
                }
            }

            p {
                font-size: 0.9em;
            }
        }

        .slider {
            width: 75%;
        }

        .slick-prev, .slick-next {
            display: none!important;
        }

        .sliderNav {
            width: 25%;
            padding-left: 1em;
            position: relative;

            .slick-slide {
                display: block;
                float: none;
                width: 100%!important;
                max-width: 100px;
                margin: 0 auto;
                padding: 0 .5em .5em .5em;
                cursor: pointer;
                opacity: .6;

                &:focus {
                    outline: none;
                }
            }

            .thumbnail {
                padding-bottom: calc(100% - 8px);
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
            }

            .slick-current {
                opacity: 1;
            }

            .slick-list {
                overflow: hidden;
            }
        }

        &__Floorplan {
            width: 100%;
            height: 100%;
            position: relative;

            &::before {
                content: ' ';
                position: absolute;
                top: 0;
                left: 0;
                width: 280px;
                height: 100%;
                opacity: .4;

            }
        }

        &__FloorplanOverlay {
            position: absolute;
            color: #FFF;
            font-weight: 600;
            text-align: center;
            padding-top: 20%;
            width: 100%;
            overflow: hidden;
        }

        .VueCarousel {
            padding: 1em 2em;

            .VueCarousel-slide {
                display: flex;
                align-items: center;

                img {
                    padding: .5em;
                }
            }
        }

        .VueCarousel-dot-container {
            button {
                padding: 5px!important;
            }
        }

        .VueCarousel-navigation-prev {
            left: 3em;
        }

        .VueCarousel-navigation-next {
            right: 3em;
        }

        @media only screen and (max-width: 767px) {
            .slider {
                width: 80%;
                height: 200px;

                .el-image {
                    height: 200px;
                }
            }

            .sliderNav {
                width: 20%;
                height: 200px;

                .slick-slide {
                    padding: 0 0.25em 0 0.25em;
                }
            }
        }
    }

    .responsive-image {
        width: 100%;
    }
</style>


